import styled from 'styled-components';

export const StyledQuestion = styled.span`
  padding-bottom: 9px;
`;
